import axios from 'axios'
import { Env } from '../infra/env'

/**
 * API for Email Confirmation.
 */
export class EmailConfirmationAPI {
  private readonly _client

  constructor(private readonly _token: string) {
    this._client = axios.create({
      baseURL: Env.IAM_API.startsWith('/')
        ? `${window.location.origin}${Env.IAM_API}`
        : Env.IAM_API,
    })

    this._client.interceptors.request.use((config) => {
      config.headers.Authorization = `Bearer ${this._token}`
      return config
    })
  }

  /**
   * Queries for the verification status of a user.
   */
  getVerificationStatus(): Promise<boolean> {
    return this._client
      .get('/v1/email-verification/status')
      .then((res) => res.data.verified)
  }

  /**
   * Resends verification emails.
   */
  async resendEmail() {
    await this._client.post('/v1/email-verification/resend')
  }
}
